import type { RcFile } from 'antd/es/upload';
import type { UseFormSetError, FieldValues, UseFormClearErrors } from 'react-hook-form';

export const checkIsSpreadSheetFileValid = ({
  file,
  fieldName,
  setError,
  clearErrors,
  maxFileSizeInMb,
  fileFormats,
}: {
  file: RcFile;
  fieldName: string;
  setError: UseFormSetError<FieldValues>;
  clearErrors: UseFormClearErrors<FieldValues>;
  maxFileSizeInMb: number;
  fileFormats: string;
}) => {
  const acceptFileTypes = ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
  const isPermittedFileType = acceptFileTypes.includes(file.type);

  if (!isPermittedFileType) {
    setError(fieldName, {
      type: 'custom',
      message: `Загрузите файл в следующих форматах: ${fileFormats}`,
    });
  }

  const sizeInMb = file.size / 1024 / 1024;
  const isValidFileSize = sizeInMb < maxFileSizeInMb;

  if (!isValidFileSize) {
    setError(fieldName, {
      type: 'custom',
      message: `Загрузите файл размером менее ${maxFileSizeInMb} Мб`,
    });
  }

  const isValidFile = isPermittedFileType && isValidFileSize;

  if (isValidFile) {
    clearErrors(fieldName);
  }

  return isValidFile;
};
